import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as surveyConfig from '../space-survey-config'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: surveyConfig.RESOURCE.payload.dimension.partialId,
      partialId: surveyConfig.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'When enabled, survey validation flags records that use sponsored functional usages without assigned sponsored accounts.',
    isOptional: false,
    name: 'Must assign sponsored accounts for sponsored functional usages',
    partialId: PartialId.Standard.create('req_sponsored_acct_assign'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
